function DonothonTimerSetting() {
  return (
    <>
      <div className="bg-[#35334D] py-8 md:px-10 sm:px-6 px-4 relative ">
        <h2
          className="CustomCardPara  !font-bold !text-left "
          style={{ fontFamily: "Gilroy", fontWeight: "700" }}
        >
          Donothon Timer
        </h2>

        <h2 className="CustomSignUpLabel !font-medium !ml-0 mt-2">
          Copy and paste this URL as a Browser Source in OBS to show a countdown
          timer that automatically updates every time you receive a tip!
        </h2>

        <div className="rounded-[10px]  bg-[#030021] md:h-[52px]  w-full  ">
          <div className="rounded-[10px]  bg-[#35334D99] h-full  p-4 mt-6  relative w-full ">
            <p
              className=" text-white text-left font-semibold text-[15px] leading-[18.38px] tracking-[0%]  break-words overflow-x-auto  whitespace-nowrap  scrollbar-hide "
              style={{ width: "80%", scrollbarWidth: "none" }}
            >
              https://sponsa.app/donothontimer?userUID=5096f
            </p>
            <button className=" md:w-[80px] md:h-[40px] w-[50px] h-[30px] absolute top-[50%] translate-y-[-50%] right-1.5  font-bold text-[15px] leading-[18.57px] tracking-[0%] HoverDarker CustomButtonAnim text-[#030021] bg-[#00FF8F]  rounded-[10px] !text-center  ">
              Copy
            </button>
          </div>
        </div>
      </div>

      <div className="bg-[#35334D] py-8 md:px-10 sm:px-6 px-4 relative ">
        <h2
          className="CustomCardPara  !font-bold !text-left "
          style={{ fontFamily: "Gilroy", fontWeight: "700" }}
        >
          Donothon Timer Customisation
        </h2>

        <h2 className="CustomSignUpLabel !font-semibold !ml-0 mt-3">
          Customise your Donothon Timer here!
        </h2>

        <div className="rounded-xl  bg-[#030021]  ">
          <div className="rounded-tl-xl rounded-tr-xl  bg-[#35334D99] text-white space-y-1 p-4 mt-4 text-[15px] leading-[100%] tracking-[0%] w-full">
            <p className="  font-semibold  ">Starting Time </p>
            <p className=" font-normal  ">
              Set your starting time here. (Format - Hours : Minutes : Seconds)
            </p>
          </div>
          <div className=" p-5 font-normal text-center text-white text-[64px] leading-[100%] tracking-[0%] ">
            00:00:00
          </div>
        </div>
        <div className=" flex items-center justify-center gap-2 my-4 ">
          <button className="font-bold text-[15px] leading-[18.57px] tracking-[0%]  block CustomButtonAnim text-[#030021] bg-[#00FF8F]  rounded-[25px]  px-[2rem] py-[0.5rem]  HoverDarker ">
            Start Timer
          </button>
          <button className="font-bold text-[15px] leading-[18.57px] tracking-[0%]  block CustomButtonAnim text-[#030021] bg-[#FFFFFF] rounded-[25px]  px-[2rem] py-[0.5rem]  HoverDarker ">
            Pause Timer
          </button>
        </div>
        <div className="rounded-xl   bg-[#030021]  ">
          <div className="rounded-xl  bg-[#35334D99] py-4 px-4 mt-5 text-white  ">
            <div>
              <p className="  font-semibold  ">Add Time (Manual) </p>
              <p className=" font-normal  ">
                Manually add time here. You can also use “-” to subtract time.
              </p>
            </div>
            <div className=" flex items-center justify-between max-w-[300px] mx-auto gap-2 my-2 ">
              <div className=" space-y-1.5 ">
                <input
                  type="number"
                  name=""
                  id=""
                  className=" w-[67px] h-[29px] bg-[#080526] rounded-[5px] font-normal text-[15px] leading-[100%] tracking-[0%] text-center text-[#FFFFFF80]  "
                  placeholder="0"
                />
                <p className=" font-normal text-[15px] leading-[100%] tracking-[0%] text-center text-white  ">
                  Hours
                </p>
              </div>
              <div className=" space-y-1.5 ">
                <input
                  type="number"
                  name=""
                  id=""
                  className=" w-[67px] h-[29px] bg-[#080526] rounded-[5px] font-normal text-[15px] leading-[100%] tracking-[0%] text-center text-[#FFFFFF80]  "
                  placeholder="0"
                />
                <p className=" font-normal text-[15px] leading-[100%] tracking-[0%] text-center text-white  ">
                  Minutes
                </p>
              </div>
              <div className=" space-y-1.5 ">
                <input
                  type="number"
                  name=""
                  id=""
                  className=" w-[67px] h-[29px] bg-[#080526] rounded-[5px] font-normal text-[15px] leading-[100%] tracking-[0%] text-center text-[#FFFFFF80]  "
                  placeholder="0"
                />
                <p className=" font-normal text-[15px] leading-[100%] tracking-[0%] text-center text-white  ">
                  Seconds
                </p>
              </div>
            </div>
          </div>
        </div>
        <button className=" mx-auto mt-4  font-bold text-[15px] leading-[18.57px] tracking-[0%]  block CustomButtonAnim text-[#030021] bg-[#00FF8F]  rounded-[25px]  px-[2rem] py-[0.5rem]  HoverDarker ">
          Add Time
        </button>
        <div className="rounded-xl   bg-[#030021]  ">
          <div className="rounded-xl  bg-[#35334D99] py-4 px-4 mt-4 text-white  ">
            <div>
              <p className="  font-semibold  ">Timer Settings </p>
              <p className=" font-normal  ">
                Set how much time each tip will add here.
              </p>
            </div>
            <div className=" flex items-center justify-start  gap-4 my-2 ">
              <div className=" space-y-1 flex items-center gap-1  ">
                <input
                  type="number"
                  name=""
                  id=""
                  className=" w-[67px] h-[29px] bg-[#080526] rounded-[5px] font-normal text-[15px] leading-[100%] tracking-[0%] text-center text-[#FFFFFF80]  "
                  placeholder="1"
                />
                <p className=" font-normal text-[15px] leading-[100%] tracking-[0%] text-center text-white  ">
                  GBP will add
                </p>
              </div>
              <div className=" space-y-1 flex items-center gap-1 ">
                <input
                  type="number"
                  name=""
                  id=""
                  className=" w-[67px] h-[29px] bg-[#080526] rounded-[5px] font-normal text-[15px] leading-[100%] tracking-[0%] text-center text-[#FFFFFF80]  "
                  placeholder="1"
                />
                <p className=" font-normal text-[15px] leading-[100%] tracking-[0%] text-center text-white  ">
                  Minute(s)
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* sldfskljdfksdjfksjdfksdfj */}
        <div className=" flex items-center justify-center gap-2 my-4 ">
          <button className="font-bold text-[15px] leading-[18.57px] tracking-[0%]  block CustomButtonAnim text-[#030021] bg-[#00FF8F]  rounded-[25px]  px-[2rem] py-[0.5rem]  HoverDarker ">
            Save Settings
          </button>
          <button className="font-bold text-[15px] leading-[18.57px] tracking-[0%]  block CustomButtonAnim text-[#030021] bg-[#FFFFFF] rounded-[25px]  px-[2rem] py-[0.5rem]  HoverDarker ">
            Pause Addition
          </button>
        </div>
      </div>
    </>
  );
}

export default DonothonTimerSetting;
